<script>
import urlConfig from './urlconfig'
const editorConfig = {
  ignore: true
}

export default {
  props: {
    type: { // 按钮类型 default / primary / success / warning / danger / text
      type: String,
      default: 'transparent',
      editor: editorConfig
    },
    text: {
      type: String,
      default: '',
      editor: editorConfig
    },
    url: {
      type: String,
      editor: editorConfig
    },
    color: {
      type: String,
      default: '',
      editor: editorConfig
    },
    backgroundColor: {
      type: String,
      default: '',
      editor: editorConfig
    },
    fontSize: {
      type: [String, Number],
      default: '14',
      editor: editorConfig
    },
    radius: {
      type: [String, Number],
      default: '',
      editor: editorConfig
    },
    border: {
      type: String,
      default: '',
      editor: editorConfig
    },
    borderColor: {
      type: [String, Number],
      editor: editorConfig
    },
    eventType: {
      type: Number,
      default: 1,
      editor: editorConfig
    },
    brandIds: {
      type: Array,
      default: () => {
        return []
      },
      editor: editorConfig
    },
    cityCode: {
      type: String,
      default: 'AR04567', // 默认查上海
      editor: editorConfig
    },
    cityName: {
      type: String,
      default: '上海', // 默认上海
      editor: editorConfig
    },
    innId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    timeType: {
      type: Number,
      default: 1,
      editor: editorConfig
    },
    daterange: {
      type: Array,
      default: () => [],
      editor: editorConfig
    },
    delayDay: {
      type: String,
      default: '',
      editor: editorConfig
    },
    stayDays: {
      type: String,
      default: '',
      editor: editorConfig
    },
    memberActCodeType: {
      type: Number,
      default: 0,
      editor: editorConfig
    },
    memberActCode: {
      type: String,
      default: '',
      editor: editorConfig
    },
    rateCode: {
      type: String,
      default: '',
      editor: editorConfig
    },
    rateType: {
      type: String,
      default: '',
      editor: editorConfig
    },
    roomTypeCode: {
      type: String,
      default: '',
      editor: editorConfig
    },
    goodsId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    categoryId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    secondCategoryId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    giftId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    customUrl: {
      type: String,
      default: '',
      editor: editorConfig
    },
    otherParams: {
      type: String,
      default: '',
      editor: editorConfig
    },
    isIgnoreChannel: {
      type: Boolean,
      default: false,
      editor: editorConfig
    },
    // 渠道按钮
    supportChannelBg: {
      type: String,
      default: 'https://h5.bestwehotel.com/storage/download/3a4fd61b-f818-4def-bd51-0ce4ab4c515c/we_1605667235942.png',
      editor: editorConfig
    },
    unSupportChannelBg: {
      type: String,
      default: 'https://h5.bestwehotel.com/storage/download/3a4fd61b-f818-4def-bd51-0ce4ab4c515c/we_1605667192357.png',
      editor: editorConfig
    },
    // 小程序跳转有关
    miniType: {
      type: String,
      default: 'travel',
      editor: editorConfig
    },
    isManualInput: {
      type: Boolean,
      default: false,
      editor: editorConfig
    },
    miniOriginId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    miniAppId: {
      type: String,
      default: '',
      editor: editorConfig
    },
    miniPath: {
      type: String,
      default: '',
      editor: editorConfig
    },
    isTesting: {
      type: Boolean,
      default: false,
      editor: editorConfig
    },
    transferParams: { // 是否透传链接参数
      type: Boolean,
      default: true,
      editor: {
        ignore: true
      }
    },
    isGioTrack: { // 是否透传链接参数
      type: Boolean,
      default: false,
      editor: editorConfig
    },
    gioModuleName: { // 是否透传链接参数
      type: String,
      default: '',
      editor: editorConfig
    },
  },
  data () {
    return {
      hotelUrl: urlConfig.prod.apphotel,
      hotellistUrl: urlConfig.prod.apphotellist,
      citylistUrl: urlConfig.prod.appcitylist,
      appDown: urlConfig.prod.appDown,
      miniArr: [
        { name: '锦江出行', id: 'travel', appId: 'wx17c6b4b79ee5868a', originId: 'gh_2426efd28100' },
        { name: '锦江美食', id: 'food', appId: 'wx20e94bed0314677c', originId: 'gh_1127b5acb8c1' },
        { name: '锦江在线', id: 'online', appId: 'wx10a799057ec0c10f', originId: 'gh_925a89997131' }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      const isApp = window.ACTSDK.isApp
      console.log('isApp>>>', isApp)
      let urlCof = urlConfig.prod
      if (this.isTesting) {
        urlCof = urlConfig.test
      }
      this.hotelUrl = urlCof.apphotel;
      this.hotellistUrl = urlCof.apphotellist
      this.citylistUrl = urlCof.appcitylist
      this.appDown = urlCof.appDown;
      // 非app内跳m站
      if (!isApp) {
        this.hotelUrl = urlCof.mhotel
        this.hotellistUrl = urlCof.mhotellist
        this.citylistUrl = urlCof.mcitylist
      }
    })
  },
  methods: {
    handleUrl () {
      let host = ''
      let param = ''
      let url = ''
      // let startTime = new Date().getTime()
      // let endTime = startTime + 1 * 24 * 60 * 60 * 1000
      let startTime = ''
      let endTime = ''
      let miniHost = ''
      let btnName = ''
      // 入住、离店时间处理
      if ([1, 2, 3].includes(this.eventType)) {
        if (this.timeType === 1) {
          // 时间范围
          if (this.daterange && this.daterange.length > 0) {
            startTime = this.daterange[0]
            endTime = this.daterange[1]
          }
        } else {
          // 特定时间 - stayDays: 连住天数 delayDay: 延迟天数
          if (this.delayDay) {
              startTime = Date.now() + parseInt(this.delayDay) * 24 * 60 * 60 * 1000
          }
          if (this.stayDays) {
              let time = parseInt(this.stayDays) * 24 * 60 * 60 * 1000
              endTime = (startTime || Date.now()) + time
          }
        }
      }
      // if (startTime < this.beginDate) { //  当前时间没有超过设定时间
      //     startTime = this.beginDate
      //     endTime = this.endDate
      // } else if (startTime < this.endDate) {
      //     endTime = this.endDate
      // }
      let dayUse = ''
      if (this.memberActCodeType === 1) {
        dayUse = '&dayUse=1'
      }

      // 1:酒店详情 2：酒店列表页 3：城市列表页 4：铂物馆商品页 5:铂物馆首页 6:铂物馆类目 7:充值页 8:自定义
      if (this.eventType === 1) {
          host = this.hotelUrl
          param = this.innId + '&beginDate=' + startTime + '&endDate=' + endTime + '&memberActCode=' + this.memberActCode + '&rateCode=' + this.rateCode + '&rateType=' + this.rateType + '&roomTypeCode=' + this.roomTypeCode + dayUse
          miniHost = '/project/hotel/views/detail/detail?from=activity&innId=' + param
          btnName = '酒店详情' + this.innId
      } else if (this.eventType === 2) {
          host = this.hotellistUrl
          param = `brand=${this.brandIds.join(',')}&cityCode=${this.cityCode}&cityName=${encodeURIComponent(this.cityName)}&checkInDate=${startTime}&checkOutDate=${endTime}&memberActCode=${this.memberActCode}&rateCode=${this.rateCode}&rateType=${this.rateType}${dayUse}`
          // param = 'brand=' + this.brandIds.join(',') + '&cityCode=' + this.cityCode + '&checkInDate=' + startTime + '&checkOutDate=' + endTime + '&memberActCode=' + this.memberActCode + '&rateCode=' + this.rateCode + dayUse
          miniHost = '/project/hotel/views/list/list?from=activity&' + param
          btnName = '酒店列表页'
      } else if (this.eventType === 3) {
          host = this.citylistUrl
          param = 'brand=' + this.brandIds.join(',') + '&checkInDate=' + startTime + '&checkOutDate=' + endTime + '&memberActCode=' + this.memberActCode + '&rateCode=' + this.rateCode + '&rateType=' + this.rateType + dayUse
          miniHost = '/project/search/views/city/city?from=activity&' + param
          btnName = '城市列表页'
      } else if (this.eventType === 4) {
          host = 'https://mall.bestwehotel.com/#/goodsDetail?productId='
          param = this.goodsId
          btnName = '铂物馆商品页'
      } else if (this.eventType === 5) {
          host = 'https://mall.bestwehotel.com/#/goodsIndex'
          btnName = '铂物馆首页'
      } else if (this.eventType === 6) {
          host = this.url
          btnName = '铂物馆类目'
          let cateParam = ''
          if (!this.secondCategoryId) {
              cateParam = 'categoryId=' + this.categoryId + '&lastpage=0'
          } else {
              cateParam = 'categoryId=' + this.secondCategoryId + '&parentId=' + this.categoryId + '&lastpage=types'
          }
          host = 'https://mall.bestwehotel.com/#/goodsIndex/categoryDetail?'
          param = cateParam
      } else if (this.eventType === 7) {
          // 不处理
          btnName = '充值页'
      } else if (this.eventType === 8) {
          host = this.customUrl
          btnName = '自定义'
          // if (/^http/.test(this.customUrl)) {
          //   miniHost = `/project/home/views/webview/index?url=${encodeURIComponent(this.getUrl(this.customUrl))}`
          // } else {
          //   miniHost = this.customUrl
          // }
      } else if (this.eventType === 9) {
          btnName = '微官网产品详情页'
          host = 'https://wemall.bestwehotel.com/hotelapp/#/project/mall/views/detail/detail'
          param = '?productId=' + this.goodsId  + '&innId=' + this.innId
          miniHost = '/project/mall/views/detail/detail' + param
      }
      // todo btnName 要加埋点
      console.log('btnName>>>>', btnName)
      // 埋点 - 生产环境放开
      // eslint-disable-next-line no-undef
      if (window._hmt) {
        const platform = window.ACTSDK.platform
        const name = window.ACTSDK.pageInfo.name
        // eslint-disable-next-line no-undef
        window._hmt.push(['_trackEvent', name + platform, 'click', btnName])
      }
      const isMiniProgram = (window.ACTSDK || {}).isMiniProgram
      url = host
      if (this.eventType !== 8) {
        url = host + param + this.otherParams
        miniHost = miniHost + this.otherParams
      }
      return (isMiniProgram && miniHost) ? miniHost : url
    },
    getUrl(path = '', query = {}) {
      if (!this.transferParams) {
        return path;
      }
      const rootSearch = (window.location.search || '').replace(/^\?/, '');
      path = path.split('?');
      const url = path.splice(0, 1)[0] || '';
      const _search = path.join('?')
      const [oldSearch, hash] = _search.split('#');
      const search = this.queryString(Object.assign(
        {},
        this.parseSearch(rootSearch),
        this.parseSearch(oldSearch),
        query
      ));
      return url + (search ? `?${search}` : '') + (hash ? `#${hash}` : '');
    },

    parseSearch(search = '') {
      const arr = search.split('&') || [];
      const query = {};
      arr.forEach(item => {
        if (!item) return;
        item = item.split('=');
        query[item[0]] = item[1] || '';
      });
      delete query.preview
      return query;
    },
    queryString(query = {}) {
      return Object.keys(query).map(key => `${key}=${query[key]}`).join('&');
    },
    weakUpMini() {
      let originId = '';
      let appId = '';
      let path = this.miniPath || '';
      if (this.isManualInput) {
        originId = this.miniOriginId;
        appId = this.miniAppId;
      } else {
        const miniType = this.miniType;
        originId = this.miniArr.filter(item => item.id === miniType)[0].originId;
        appId = this.miniArr.filter(item => item.id === miniType)[0].appId;
      }
      let platform = 'jj';
      if (window.ACTSDK) {
        platform = window.ACTSDK.platform;
      }
      console.log('platform>>', '小程序信息：：：', 'originId>', originId, 'appId:>>', appId);
      const that = this;
      if (['jj', 'botao', 'bgsh', 'bgsh_oversea'].includes(platform)) {
        window.wehotelSDK.launchMiniProgram({
          data: {
            miniprogramType: 0, // 0: 正式包，1:测试包，2：开发包
            userName: originId,
            path: path
          },
          success: function(data) {
            console.log('唤醒小程序回调成功');
            // 5.2.4 版本的添加一个toast提醒，之后的版本就不需要了
            if (window.wehotelSDK.appVersion <= 5.0204) {
              setTimeout(() => {
                that.$toast('如未能正常拉起微信，请手动打开~');
              }, 1000)
            };
          }
        })
      } else if (['wx_mini'].includes(platform)) {
        // todo 需要小程序支持才可以
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/props.vue